import { defineStore } from "pinia";
import Album from "@/models/Albums";
import Video from "@/models/Videos";
import { AlbumAPI } from "@/api/AlbumAPI";
import { VideoAPI } from "@/api/VideoAPI";

export const useMainStore = defineStore("main", {
  state: () => ({
    loaded: false,
    albums: [] as Album[],
    albumsCover: [] as Album[],
    videos: [] as Video[],
  }),
  actions: {
    async fetchAlbums(id: number) {
      try {
        const album = await AlbumAPI.getOneAlbum(id);
        if (this.albums.find((album) => album.id === id)) {
          console.log("Already loaded");
        } else {
          this.albums.push(album);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchAlbumsCover() {
      const result = await AlbumAPI.getAllAlbumsCover();
      this.albumsCover = result;
    },
    async fetchVideos() {
      const result = await VideoAPI.getAllVideos();
      this.videos = result;
    },
  },
});
